import { T_Podcast, User } from "types";

export const fakeUser: User = {
  _id: "1",
  firstName: "Raymond",
  lastName: "Reddington",
  email: "red.reddington@multiplayer.work",
  created: new Date(),
  profileUrl: "https://xsgames.co/randomusers/avatar.php?g=pixel",
  settings: {
    timeZone: "America/New_York",
    //email: {
    //  canReceiveNews: true,
    //  canReceivePromotions: true,
    //  canReceiveUpdates: true,
    //  deliveryTime: '6:00',
    //  hasNotification: true,
    //  meetingPrep: true,
    //  morningSummary: true,
    //  notSendIfNoEvents: false,
    //  notifyPerAttendee: false,
    //  timeToReceivePrep: 15,
    //},
    //pushNotification: {
    //  deliveryTime: '6:00',
    //  hasNotification: true,
    //  meetingPrep: true,
    //  morningSummary: true,
    //  notSendIfNoEvents: false,
    //  notifyPerAttendee: false,
    //  timeToReceivePrep: 15,
    //},
  },
};

export const fakePodcast: T_Podcast[] = [
  {
    type: "daily",
    url: "https://storage.googleapis.com/multiplayer-images-public/daily-briefing-podcast-66ea02d2fe698d7fb13a98da",
    chapter: "briefing",
    transcript: `Good morning, Djibril! It's Friday, October 11th, 2024, and I'm here to give you a quick rundown of your day. The weather in Sakarya is mostly cloudy this morning, with temperatures hovering around 68°F or 20°C. Expect it to warm up to a pleasant 81°F or 27°C by midday, with partly cloudy skies throughout the afternoon. A perfect day to enjoy some sunshine, don't you think? 

Now, let's dive into your schedule. Today seems to be a rare occasion with no meetings planned. It might be a good opportunity to focus on some deep work or catch up on any pending tasks. If you ever decide to connect your Google Calendar, I could help you keep track of your meetings and even provide insights about people you haven't met before. Just something to consider for the future!

Moving on to emails and notifications… I went ahead and archived 39 emails for you, mostly newsletters, notifications, and some sales pitches. However, there's one email that might need your attention. It's from yourself, Djibril, with the subject "Regarding payment." Just a gentle reminder that your payment is overdue, so it might be worth addressing that soon.

There are no significant events or changes in your calendar today, but if anything comes up, I'll be sure to keep you updated.

And that wraps up our briefing for today. Enjoy the cloud breaks and the warm afternoon, and remember, it's always a good idea to take a little break if you can. Have a productive day, Djibril, and let's tackle this Friday with focus and calm. Talk to you soon!`,
    audioDuration: 97.344,
    created: new Date(),
  },
  {
    type: "daily",
    url: "https://storage.googleapis.com/multiplayer-images-public/daily-newsletter-podcast-66ea02d2fe698d7fb13a98da",
    chapter: "newsletter",
    transcript: `Hey Djibril, and happy Friday! It's October 11th, 2024, and I hope you're having a great start to your day in Sakarya. Let's dive into today's news highlights and see what's happening in the world...

Starting with the tech industry, Meta is making waves with its focus on probability questions during interviews. It's an interesting approach, possibly reflecting their emphasis on analytical skills and decision-making under uncertainty. As a Lead Software Engineer, you might find this strategy quite intriguing, considering how probability can play a crucial role in software development and AI.

Speaking of AI, there's exciting news from the Nobel Prize announcements. Geoff Hinton and John Hopfield have been awarded the 2024 Physics Nobel Prize for their pioneering work in AI. It's fantastic to see AI research getting such prestigious recognition. It makes one wonder about the future impact of AI across various fields, including your own work at Multiplayer.

On a different note, the entertainment industry is buzzing with Elf Labs' innovative approach to intellectual property. They're leveraging AR and VR to revolutionize beloved characters like Cinderella and Snow White. It's a fascinating blend of technology and storytelling that could redefine how we interact with media.

In the realm of civil rights, we remember the late Imam Mahdi Bray, a dedicated activist who tirelessly advocated for justice and equality. His legacy is a reminder of the power of standing up for what’s right, a sentiment that resonates across all walks of life.

Now, if you're looking for some fun activities to unwind this weekend in Sakarya, you're in luck! How about a visit to Sapanca Lake for a relaxing day by the water? Or, if you're feeling adventurous, an ATV safari in Masukiye could be just the thrill you need. For a touch of culture, the Historical Hanımeli Mansion in Taraklı offers a glimpse into the region's rich history.

And if you're in the mood for some modern entertainment, check out the latest movies at local cinemas or explore the shopping centers like Serdivan AVM. There's always something to do to recharge and enjoy your time off.

As we wrap up, remember to take a moment for yourself, whether it's exploring the outdoors or simply enjoying a good meal. Have a fantastic weekend, Djibril, and catch you next time!`,
    audioDuration: 145.368,
    created: new Date(),
  },
];
